import Flexbox from "../../common/Flexbox";
import { SidebarItem } from "../../molecules";
import type { SidebarProps } from "./Sidebar.types";

export default function Sidebar({ routes }: SidebarProps) {
  return (
    <Flexbox className="sticky top-0 h-screen w-64 shrink-0 overflow-auto p-2">
      <Flexbox
        fullHeight
        fullWidth
        className="rounded-[20px] border border-[##EFF3F9] bg-white px-6 pt-10"
      >
        <img src={"/flexLogo.png"} alt="Logo" className="mx-auto w-28" />
        <Flexbox className="mt-10 w-full gap-2">
          {routes.map((item) => (
            <SidebarItem
              key={item.label}
              label={item.label}
              href={item.href}
              Icon={item.Icon}
            />
          ))}
        </Flexbox>
      </Flexbox>
    </Flexbox>
  );
}
